import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { AccountingPeriodService } from '../modules/accounts/accounting-period/services/accounting-period.service';
import * as CryptoJS from 'crypto-js';
import { BehaviorSubject, Observable } from 'rxjs';
import { MotorvehiclesService } from '../modules/accounts/notes/motorvehicles/motorvehicles.service';
import moment from 'moment';
import { FormGroup } from '@angular/forms';
import { FinancialpositionService } from '../modules/accounts/financialposition/financialposition.service';
import Swal from 'sweetalert2';
import { CompanyServiceService } from '../modules/company/companylist/company-service.service';
import { ToastrService } from 'ngx-toastr';
import { OAuthService } from 'angular-oauth2-oidc';
import { SubscriptionDataService } from './Subscription/subscription-data.service';
import { AccountingpolicyService } from '../modules/accounts/notes/accountingpolicies/accountingpolicy.service';
import { ApprovalstatusService } from '../modules/accounts/approvalstatus/service/approvalstatus.service';
import { ConfigurationService } from '../Configuration/configuration.service';
import { data } from 'jquery';
import { ReportSelectionModel } from '../modules/tools/reports/Models/ReportSelectionModel';
import { BusinessModel, TrailbalancemodelForImpAcctsoft, UserRegistrationModel } from '../core/models/UserRegistrationModel';
import { GlobalLogoutService } from './andicaCentralServices/global-logout.service';
@Injectable({
  providedIn: 'root'
})

export class CommonService {
  masterUrl = this.ConfigService.getAPIBaseUrl() + 'api/MasterData'
  pageSelectionUrl = this.ConfigService.getAPIBaseUrl() + 'api/PageSelection'
  trailBalanceUrl = this.ConfigService.getAPIBaseUrl() + 'api/TrailBalance'
  companyInformation = this.ConfigService.getAPIBaseUrl() + 'api/CompanyInformation'
  importUrl = this.ConfigService.getAPIBaseUrl() + 'api/Import'
  public validService = new BehaviorSubject<Array<any>>([]);
  validdata = this.validService.asObservable()
  notesUrl = this.ConfigService.getAPIBaseUrl() + 'api/NotesMenu'
  isDesc: boolean; column: any;
  paginationDropDown = 10;
  currentAccountingPeriodTo: any;
  currentAccountingPeriodFrom: any;
  StartdateLastAccountingPeriod: any;
  FirstYearAccounting: any;
  pagelength: any; countryData: any; companyLegalformdata: any; entityStatusdata: any;
  AccountTemplateId: any; AccountTypeId: any; DimensionLegalFormEntity: any; allPagesdata: any;
  tangibleAssetsValidation: any;
  getAcctSoftUser: any;
  getAcctSoftBusiness: any;
  CAPeriodTo: any;
  CAPeriodFrom: any;
  ComputationAccountingPeriodToDate: any;
  StartDate: any;
  EndDate: any;
  LastyearEndDate: any;
  StartdateLastAP: any;
  FYAccounting: any;
  LastACPeriod: any;
  StartYear: any;
  LastYear: any;
  StartdateLastAPLY: any
  LYAccountingPeriod: any;
  showControl: boolean = false
  NotesList: any;
  Landandbuildings: boolean = false;
  PlantMachinery: boolean = false;
  Furnitureandfittings: boolean = false;
  OfficeEquipment: boolean = false;
  MotorVehicles: boolean = false;
  headerName: any; leaglformId: any;
  BalanceSheetForm: any
  tangablevalue: any
  routeToCompanyList: boolean;
  legalFormName: any; countryName: any; entityId: any; companyName: any;
  pageselectionforSubmission: any = []
  centralUserId: any;
  UserId: any;
  LoggedInUserId: any; MouseEvent: any; preparent: any; NotesName: any
  TUStartDate: any;
  TUEndDate: any; TUEndDate1: any; isComputation: boolean; innertext: any; computationid: any;
  APPeriodId: any; showBubble: boolean; showbubblevalue: any; status: boolean; viewInint: boolean; BusinessLicenceCount: any = 0; LiveSubmissionCount: any; totalBusinessesList: any; submissionData: any = [];
  RegistrationType: any; PlanId: any; PricingId: any; ProductId: any; DonotShowStartHere: any; TaxYear: any; NumberOfCompanies: any; NumberOfUsers: any; UserName: any; userCompanyname: any; emailId: any; mobileNumber: any; UserLoginHistoryId: any;
  ShowUpgrade: boolean = false; Version: any
  ShowRenew: boolean = false; sideMenuNotes: any
  NosearchRecords: boolean; isSubmitRequest: boolean; accountsStatus: boolean = false; UserLicenceName: any
  showBubbleSpinner
  /*  apiUrl = this.ConfigService.getAPIBaseUrl() + 'api/ThirdPartyAgents/';*/
  url = this.ConfigService.getAPIBaseUrl() + 'api/AccountingPeriodBasicInfo'
  acctSoftURL: any = this.ConfigService.acctSoftAPIurl;
  andicaCentralURL: any = this.ConfigService.andicaCentralURL;
  constructor(private datepipe: DatePipe, private http: HttpClient, private accountsService: AccountingPeriodService, private motor: MotorvehiclesService, public Financialposition: FinancialpositionService,
    private companyService: CompanyServiceService, private toastr: ToastrService, private oauthService: OAuthService, private SubscriptionApiService: SubscriptionDataService, private ConfigService: ConfigurationService
    , private globalLogoutService: GlobalLogoutService) { }


  private navigationdata = new BehaviorSubject<number>(null);
  Isnavigationdata = this.navigationdata.asObservable();

  private import = new BehaviorSubject<any>(null);
  ImportData = this.import.asObservable();

  private taxyear = new BehaviorSubject<any>(null);
  TaxYearLicence = this.taxyear.asObservable();

  private Licence = new BehaviorSubject<any>(null);
  LicenceList = this.Licence.asObservable();

  private AccountingPeriod = new BehaviorSubject<any>(null)
  openAccountingPeriodList = this.AccountingPeriod.asObservable()

  private clearAllFields$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  clearAllFields = this.clearAllFields$.asObservable();
  private loadBusiness$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  loadBusiness = this.loadBusiness$.asObservable();
  get getClearAllFields(): boolean {
    return this.clearAllFields$.value;
  }
  setClearAllFields(computations: boolean) {
    debugger
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
    if (this.APPeriodId && location.pathname != "/computation") {
      Swal.fire({
        title: "Andica Accounts Production",
        text: 'You are about to clear all the visible fields, do you want to continue?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        allowOutsideClick: false
      }).then((result) => {
        debugger
        if (result.value) {
          this.clearAllFields$.next(computations);
        }
        this.clearAllFields$.next(false)
      })
    }
  }

  setOpenAccountingPeriod(data) {
    this.AccountingPeriod.next(data)
  }

  IsTaxYear(data) {
    this.taxyear.next(data)
  }
  IsImportEnable(data) {
    this.import.next(data);
  }
  LicenceBehaviour(data) {
    this.Licence.next(data)
  }
  setLoadBusiness(Load: boolean) {
    this.loadBusiness$.next(Load)
  }
  Isnavdata(data) {
    this.navigationdata.next(data);
  }
  sort(property, data) {
    debugger
    this.isDesc = !this.isDesc; //change the direction    
    this.column = property;
    let direction = this.isDesc ? 1 : -1;
    data.sort(function (a, b) {
      if (property.includes('Date') || property.includes('Period')) {
        if (new Date(a[property]) < new Date(b[property])) {
          return -1 * direction;
        }
        else if (new Date(a[property]) < new Date(b[property])) {
          return 1 * direction;
        }
        else {
          return 1 * direction;
        }
      }
      else {
        if (a[property] != null && b[property] != null) {
          if (a[property].toLowerCase() < b[property].toLowerCase()) {
            return -1 * direction;
          }
          else if (a[property].toLowerCase() > b[property].toLowerCase()) {
            return 1 * direction;
          }
          else {
            return 1 * direction;
          }
        }
        else {
          if (a[property] == null) {
            return -1 * direction;
          }
          else if (b[property] == null) {
            return 1 * direction;
          }
          else {
            return 1 * direction;
          }
        }
      }
    });
  }

  dateTransform(date) {
    return this.datepipe.transform(date, "dd/MM/yyyy");
  }

  getLegalformCompanies() {
    return this.http.get(this.masterUrl + '/GetCompanyLegalForm')
  }

  getCountry() {
    debugger
    return this.http.get(this.masterUrl + '/GetCountry')
  }

  getAccountingPeriod_AccountsTemplate(LegalformId, EntityId) {
    return this.http.get(this.masterUrl + '/GetAccountingPeriod_AccountsTemplate?LegalFormId=' + LegalformId + '&EntityId=' + EntityId)
  }

  getAccountingPeriod_AccountsType() {
    return this.http.get(this.masterUrl + '/GetAccountingPeriod_AccountsType')
  }

  getStatusOfEntity() {
    return this.http.get(this.masterUrl + '/GetOperationalStatusOfEntity')
  }

  getAllPages(legalFormId, entityId, accountTemplateId, accountTypeId, APPeriodId) {
    debugger
    this.leaglformId = legalFormId
    return this.http.get(this.pageSelectionUrl + '/GetPages?LegalFormId=' + legalFormId + '&EntityId=' + entityId + '&AccountsTemplateId=' + accountTemplateId + '&AccountsTypeId=' + accountTypeId + '&APPeriodId=' + APPeriodId)
  }

  getBasicInfo(id) {
    debugger;
    this.accountsService.getBasicInfoData(id).subscribe((data: any) => {
      this.AccountTemplateId = data.DimensionLegalFormEntity;
      this.AccountTypeId = data.AccountType ? data.AccountType : 0;
      this.companyName = data.EntityCurrentLegalOrRegisteredName;
      //localStorage.setItem("CAPeriodFrom", data.StartDateForPeriodCoveredByReport)
      //localStorage.setItem("CAPeriodTo", data.EndDateForPeriodCoveredByReport)
      //localStorage.setItem("StartdateLastAccountingPeriod", data.StartDateofLastAccountingPeriod)
      //localStorage.setItem("FirstYearAccounting", data.FirstYear)
      this.currentAccountingPeriodFrom = new Date(data.StartDateForPeriodCoveredByReport)
      this.currentAccountingPeriodTo = new Date(data.EndDateForPeriodCoveredByReport)
      this.StartdateLastAccountingPeriod = new Date(data.StartDateofLastAccountingPeriod)
      this.FirstYearAccounting = data.FirstYear
      this.getNotesData()
      this.getPageselection(id);
      this.getCommonData()
      this.getIncomeStatementsHeaders()
    })
  }
  getCommonData() {
    debugger;   
    this.CAPeriodFrom = moment(this.currentAccountingPeriodFrom, "DD/MM/YYYY").format("DD/MM/YYYY")
    this.CAPeriodTo = moment(this.currentAccountingPeriodTo, "DD/MM/YYYY").format("DD/MM/YYYY")
    this.StartDate = moment(this.currentAccountingPeriodFrom, "DD/MM/YYYY").format('DD MMMM YYYY')
    this.EndDate = moment(this.currentAccountingPeriodTo, "DD/MM/YYYY").format('DD MMMM YYYY')
    this.LYAccountingPeriod = moment(this.currentAccountingPeriodFrom, "DD/MM/YYYY").subtract(1, "day").format("DD/MM/YYYY")
    this.LastyearEndDate = moment(this.LYAccountingPeriod, "DD/MM/YYYY").format('DD MMMM YYYY')
    this.StartdateLastAP = moment(this.StartdateLastAccountingPeriod, "DD/MM/YYYY").format("DD/MM/YYYY")
    this.StartdateLastAPLY = moment(this.StartdateLastAccountingPeriod, "DD/MM/YYYY").format("DD MMMM YYYY")
    this.StartYear = moment(this.currentAccountingPeriodTo, "DD/MM/YYYY").format('YYYY')
    this.FYAccounting = this.FirstYearAccounting;
    if (this.FYAccounting != true && this.StartdateLastAP) {
      this.showControl = true
      this.LastYear = moment(this.currentAccountingPeriodFrom, "DD/MM/YYYY").subtract(1, "day").format("YYYY")
      // this.LYAccountingPeriod = moment(this.currentAccountingPeriodFrom, "DD/MM/YYYY").subtract(1, "day").format("DD/MM/YYYY")
    }
    else {
      this.showControl = false
    }
  }

  getPageselection(id) {
    debugger;
    var entityid = CryptoJS.AES.decrypt(localStorage.getItem("EntityId"), "APS").toString(CryptoJS.enc.Utf8)

    var legalformId = CryptoJS.AES.decrypt(localStorage.getItem("legalFormId"), "APS").toString(CryptoJS.enc.Utf8)
    this.getAllPages(legalformId, entityid, this.AccountTemplateId, this.AccountTypeId, id).subscribe((data: any) => {
      this.allPagesdata = data;
      const rtRaw = localStorage.getItem('reportType');
      const rt = (rtRaw || '').toString().trim().toLowerCase();
      const isAudited = (rt === '2') || (rt === 'audited');
      if (!isAudited) {
        this.allPagesdata = data.filter(page => page.FormName !== 'Auditors Report');
      }
      else {
        //const apPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
        //this.allPagesdata.push({ FormId: 9, FormName: 'Auditors Report', IsDefault: true, IsDisabled: true, APPeriodId: +CryptoJS.AES.decrypt(localStorage.getItem("EntityId"), "APS").toString(CryptoJS.enc.Utf8),AccountTypeId: null });
        const auditorsExists = this.allPagesdata.some(
          x => x.FormName === 'Auditors Report'
        );

        if (!auditorsExists) {
          const apPeriodId = Number(
            CryptoJS.AES.decrypt(
              localStorage.getItem("APPeriodId"),
              "APS"
            ).toString(CryptoJS.enc.Utf8)
          );

          this.allPagesdata.push({
            FormId: 9,
            FormName: 'Auditors Report',
            IsDefault: true,
            APPeriodId: apPeriodId,
            AccountTypeId: null,
            IsDisabled: true,
          });
        }
      }

      //const orderedPages = [
      //  'Directors Report',
      //  'Members Report',
      //  'Auditors Report',
      //  'Income Statement',
      //  'Statement of Comprehensive Income',
      //  'Statement of Financial Position',
      //  'Statement of Changes in Equity',
      //  'Cash Flow Statement',
      //  'Notes'
      //];

      //this.allPagesdata.sort((a, b) => {
      //  const aIndex = orderedPages.indexOf(a.FormName);
      //  const bIndex = orderedPages.indexOf(b.FormName);

      //  return (
      //    (aIndex === -1 ? 999 : aIndex) -
      //    (bIndex === -1 ? 999 : bIndex)
      //  );
      //});

      if (localStorage.getItem("SubmitStatus") == "true") {
        for (let i = 0; i < this.allPagesdata.length; i++) {
          this.allPagesdata[i].IsDisabled = true
        }
      }

    })
  }
  getNextPageSelection(page, selectedPagesData) {
    debugger
    var next_PageName;
    if (this.AccountTemplateId == 9 || this.AccountTemplateId == 10) {
      selectedPagesData.push({ FormId: 8, FormName: 'approvalstatement', IsDefault: true, IsDisabled: true })
    }
    else
      selectedPagesData.push({ FormId: 7, FormName: 'approvalstatus', IsDefault: true, IsDisabled: true })
    selectedPagesData = selectedPagesData.filter(x => x.IsDefault == true)
    selectedPagesData = selectedPagesData.sort((a, b) => a.FormId - b.FormId)
    selectedPagesData.sort((a, b) => a.FormId - b.FormId);

    const index = selectedPagesData.findIndex(item => item.FormId === 10);

    if (index !== -1) {
      const [form10] = selectedPagesData.splice(index, 1);
      const insertindex = selectedPagesData.findIndex(item => item.FormId === 3);
      selectedPagesData.splice(insertindex+1, 0, form10);
    }
    if (selectedPagesData.length > 0) {
      if (page != "") {
        for (let i = 0; i < selectedPagesData.length; i++) {

          if (selectedPagesData[i].FormName == page) {
            if (selectedPagesData[i + 1]) {
              next_PageName = selectedPagesData[i + 1].FormName
            }
            else {
              next_PageName = selectedPagesData[i].FormName
            }
          }
        }
      }
      else {
        next_PageName = selectedPagesData[0].FormName
      }
    }
    return next_PageName.replaceAll(' ', '').toLocaleLowerCase();
  }

  getPreviousPageSelection(page, selectedPagesData) {
    debugger
    var previous_PageName;
    if (this.AccountTemplateId == 9 || this.AccountTemplateId == 10) {
      selectedPagesData.push({ FormId: 8, FormName: 'approvalstatement', IsDefault: true, IsDisabled: true })
    }
    else
      selectedPagesData.push({ FormId: 7, FormName: 'approvalstatus', IsDefault: true, IsDisabled: true })
    selectedPagesData = selectedPagesData.filter(x => x.IsDefault == true)
    selectedPagesData = selectedPagesData.sort((a, b) => a.FormId - b.FormId)
    if (selectedPagesData.length > 0) {
      if (page != "") {
        for (let i = 0; i < selectedPagesData.length; i++) {

          if (selectedPagesData[i].FormName == page) {
            if (selectedPagesData[i - 1]) {
              previous_PageName = selectedPagesData[i - 1].FormName
            }
            else {
              previous_PageName = 'thirdpartyagents'
            }
          }
        }
      }
      else {
        previous_PageName = selectedPagesData[0].FormName
      }
    }
    return previous_PageName.replaceAll(' ', '').toLocaleLowerCase();
  }

  getTrailBalanceNames(APPeriodId, TrialBalanceType) {
    return this.http.get(this.trailBalanceUrl + '/GetTrainBalanceNames?APPeriodId=' + APPeriodId + '&TrialBalanceType=' + TrialBalanceType);
  }
  getTrailBalanceNamesnew(APPeriodId, TrialBalanceType) {
    debugger
    return this.http.get(this.trailBalanceUrl + '/GetTrainBalanceNamesnew?APPeriodId=' + APPeriodId + '&TrialBalanceType=' + TrialBalanceType);
  }
  getTrailBalanceNamesLY(APPeriodId, TrialBalanceType) {
    return this.http.get(this.trailBalanceUrl + '/GetTrainBalanceNamesLY?APPeriodId=' + APPeriodId + '&TrialBalanceType=' + TrialBalanceType);
  }
  insertTrailBalance(data) {
    return this.http.post(this.trailBalanceUrl + '/InsertTrailBalance', data)
  }

  //insertAcctsoftTrialBalance(APPeriodId, data) {
  //  return this.http.get(this.trailBalanceUrl + '/InsertAcctsoftTrialBalance?APPeriodId=' + APPeriodId + '&AccsoftTrailBalance=' + data);
  //}
  ImportAcctsoftTrialBalance(APPeriodId: any, TrialBalanceType:any, data: any[]) {
    // Send the array securely in the HTTP request body instead of the URL
    const url = `${this.trailBalanceUrl}/ImportAcctsoftTrialBalance?APPeriodId=${APPeriodId}&TrialBalanceType=${TrialBalanceType}`;
    return this.http.post(url, data);
  }

  insertjournaldata(data) {
    return this.http.post(this.trailBalanceUrl + '/InsertJournalDatas', data)
  }
  getJournalData(id, value, APPeriodId) {
    debugger
    return this.http.get(this.trailBalanceUrl + '/GetJournalsList?id=' + id + '&value=' + value + '&APPeriodId=' + APPeriodId);
  }

  getIncomeStatementsHeaders() {
    debugger
    var entityid = CryptoJS.AES.decrypt(localStorage.getItem("EntityId"), "APS").toString(CryptoJS.enc.Utf8)
    var legalformId = CryptoJS.AES.decrypt(localStorage.getItem("legalFormId"), "APS").toString(CryptoJS.enc.Utf8)
    this.getAccountingPeriod_AccountsTemplate(legalformId, entityid).subscribe((data: any) => {
      this.headerName = data.filter(x => x.AccountsTemplateId == this.AccountTemplateId)[0]?.AccountsTemplateName;
    })
  }

  addDecimals(form: FormGroup) {
    for (var control in form.controls) {
      if (typeof form.get(control).value == "number") {
        form.get(control).setValue(form.get(control).value.toFixed(2))
      }
    }
  }
  undefinedSettoNull(form: FormGroup) {
    for (var control in form.controls) {
      if (form.get(control).value == undefined) {
        form.get(control).setValue(null)
      }
    }
  }

  getNextNoteSelection(page, selectednote) {
    debugger
    var next_PageName;
    selectednote = selectednote.filter(x => x.IsChecked == true)
    if (selectednote.length > 0) {
      if (page != "") {
        for (let i = 0; i < selectednote.length; i++) {

          if (selectednote[i].NotesDescription == page) {
            if (selectednote[i + 1]) {
              next_PageName = selectednote[i + 1].NotesDescription
            }
            else {
              next_PageName = selectednote[i].NotesDescription
            }
          }
        }
      }
      else {
        next_PageName = selectednote[0].NotesDescription
      }
    }
    if (next_PageName.includes(" "))
      return next_PageName.replaceAll(' ', '').toLocaleLowerCase();
    else
      return next_PageName.toLocaleLowerCase();
  }
  getNextjumpSelection(page, selectednote) {
    debugger
    var next_PageName;

    if (selectednote.length > 0) {
      if (page != "") {
        if (selectednote == page) {
          if (selectednote) {
            next_PageName = selectednote
          }
          else {
            next_PageName = selectednote
          }
        }
      }
      else {
        next_PageName = selectednote
      }
    }
    return next_PageName.replaceAll(' ', '').toLocaleLowerCase();
  }
  getBackSelection(page, selectednote) {
    var next_PageName;
    selectednote = selectednote.filter(x => x.IsChecked == true)
    if (selectednote.length > 0) {
      if (page != "") {
        for (let i = 0; i < selectednote.length; i++) {

          if (selectednote[i].NotesDescription == page) {
            if (selectednote[i - 1]) {
              next_PageName = selectednote[i - 1].NotesDescription
            }
            else {
              next_PageName = selectednote[i].NotesDescription
            }
          }
        }
      }
      else {
        next_PageName = selectednote[0].NotesDescription
      }
    }
    return next_PageName?.replaceAll(' ', '')?.toLocaleLowerCase();
  }
  getNoteMenuList(id, APPeriodId) {
    debugger
    return this.http.get(this.notesUrl + '/GetNotesData?id=' + id + '&APPeriodId=' + APPeriodId)
  }
  Sidenodes: any;
  insertNoteMenu(data) {
    debugger
    this.Sidenodes = data;
    return this.http.post(this.notesUrl + '/InsertNoteMenu', data)
  }
  getNotesData() {
    debugger
    var APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)
    this.getNoteMenuList(this.AccountTemplateId, APPeriodId).subscribe(data => {
      this.NotesList = data
      //this.sideMenuNotes = data
      //if (this.AccountTypeId == 3) {
      //  this.sideMenuNotes = this.sideMenuNotes.filter(x => x.NotesDescription != 'Operating profit/(loss)' && x.NotesDescription != 'Turnover / revenue' && x.NotesDescription != 'Taxation')
      //}
      this.NotesList = this.NotesList.filter(x => x.IsChecked == true)
      for (let i = 0; i < this.NotesList.length; i++) {
        if (this.NotesList[i].NotesDescription == 'Land and buildings') {
          this.Landandbuildings = true;
        } if (this.NotesList[i].NotesDescription == 'Plant Machinery') {
          this.PlantMachinery = true;
        } if (this.NotesList[i].NotesDescription == 'Furniture and fittings') {
          this.Furnitureandfittings = true;
        } if (this.NotesList[i].NotesDescription == 'Office Equipment') {
          this.OfficeEquipment = true;
        } if (this.NotesList[i].NotesDescription == 'Motor Vehicles') {
          this.MotorVehicles = true;
        }
        else {
        }
      }
    })


  }

  gettotaltanagable() {
    debugger
    var APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)
    this.motor.getTangableData(APPeriodId).subscribe((data: any) => {
      if (data) {
        this.tangibleAssetsValidation = data;
      } else {
        this.tangibleAssetsValidation.LandAndBuilding_PropertyPlantEquipment_End = 0;
        this.tangibleAssetsValidation.LandAndBuilding_PropertyPlantEquipment_Start = 0;
        this.tangibleAssetsValidation.Officeequipment_PropertyPlantEquipment_End = 0;
        this.tangibleAssetsValidation.Officeequipment_PropertyPlantEquipment_Start = 0;
        this.tangibleAssetsValidation.Furniturefittings_PropertyPlantEquipment_Start = 0;
        this.tangibleAssetsValidation.Furniturefittings_PropertyPlantEquipment_End = 0;
        this.tangibleAssetsValidation.Plantmachinery_PropertyPlantEquipment_End = 0;
        this.tangibleAssetsValidation.Plantmachinery_PropertyPlantEquipment_Start = 0;
        this.tangibleAssetsValidation.BalanceSheet_CY = 0
        this.tangibleAssetsValidation.BalanceSheet_LY = 0
      }
    })
  }

  DeleteNotesData(APPeriodId, NotesJson) {
    return this.http.post(this.notesUrl + '/DeleteNotes?&APPeriodId=' + APPeriodId + '&NotesJson=' + NotesJson, "")
  }

  getImportPageSelectionData(TempalteId, CompanyId, AppPeriodId) {
    return this.http.get(this.importUrl + '/GetImportPageSelection?&AccountTemplateId=' + TempalteId + '&CompanyId=' + CompanyId + '&APPeriodId=' + AppPeriodId)
  }
  insertImportData(data) {
    //data = JSON.parse(data)
    return this.http.post(this.importUrl + '/InsertImportData', data);
  }
  showBubbledata(AccountTemplateId, CompanyId, ApperiodId) {
    this.getImportPageSelectionData(AccountTemplateId, CompanyId, ApperiodId).subscribe((data) => {
      this.showBubble = data[0].ImportStatus
    })
  }

  CreateNewCompany: boolean = false;
  OpenexistingcompanytostartpreparingAccounts: boolean = false;
  DisplayAccountingPeriodlist: boolean = false;
  PrintiXBRLReport: boolean = false;

  headertags: boolean = false
  headertags1: boolean = false
  isLicenceExpired: boolean;
  deactivated: boolean
  getLoginDetails(LoginName) {
    //if (!this.viewInint) {
    debugger;
    this.companyService.getLoginDetails(LoginName).subscribe((data: any) => {
      if (data.length > 1) {
        this.deactivated = false
        this.centralUserId = data[0].CentralUserId
        localStorage.setItem('MasterId', data[0].CentralUserId)
        this.UserId = data[0].UserId
        this.TUStartDate = data[0].StartDate
        this.TUEndDate = data[0].EndDate
        this.RegistrationType = data[0].RegistrationType
        this.PricingId = data[0].PricingId
        this.PlanId = data[0].PlanId
        this.ProductId = data[0].ProductId
        this.TaxYear = data[0].TaxYear; localStorage.setItem("TaxYear", data[0].TaxYear)
        localStorage.setItem("UserEmail", data[0].EmailId);
        this.Version = new Date(data[0]?.TaxYear).getFullYear() - 1
        this.IsTaxYear(true)
        this.NumberOfCompanies = data[0].NumberOfCompanies >= 99999 ? 'Unlimited' : data[0].NumberOfCompanies
        this.NumberOfUsers = data[0].NumberOfUsers >= 99999 ? 'Unlimited' : data[0].NumberOfUsers
        this.UserName = data[1]?.FirstName + ' ' + (data[1]?.LastName == null ? '' : data[1]?.LastName);
        this.UserLicenceName = data[0]?.FirstName + ' ' + (data[0]?.LastName == null ? '' : data[0]?.LastName);
        this.emailId = data[0].EmailId
        this.userCompanyname = data[0].UserCompanyName
        this.mobileNumber = data[0].Mobilenumber
        this.LoggedInUserId = data[1].UserId
        this.LiveSubmissionCount = data[1].SubmissionCount
        this.submissionData = data[1]?.SubmissionData
        this.DonotShowStartHere = data[0].DonotShowStartHere
        localStorage.setItem('LoginuserId', data[1].UserId)
        if (localStorage.getItem("temploginhistory") != "1")
          this.insertTime()
        this.LicenceBehaviour(true)
        if (this.NumberOfCompanies == 'Unlimited' || this.NumberOfUsers == 'Unlimited')
          this.ShowUpgrade = true
        var date = new Date()

        data[0].TUEndDate = data[0].EndDate != null ? data[0].EndDate.split('T')[0] : null
        var TUEndDate = data[0].EndDate
        var TUEndtime = data[0].EndDate.split('T')[1]
        this.parseDate(data);
        var today = new Date();
        today.setHours(0, 0, 0, 0)
        var todayExact = moment(today).format("DD/MM/YYYY HH:mm:ss");
        var licenseEndDate = moment(new Date(TUEndDate), "DD/MM/YYYY").format("DD/MM/YYYY HH:mm:ss");
        var ms = moment(licenseEndDate, "DD/MM/YYYY HH:mm:ss").diff(moment(todayExact, "DD/MM/YYYY HH:mm:ss"));
        (ms <= 0) ? this.isLicenceExpired = true : this.isLicenceExpired = false;
        this.TUEndDate1 = data[0].TUEndDate
        if (localStorage.getItem("tempStorage") == "1") {
          if (!this.isLicenceExpired) {
            if (moment(data[0].EndDate, "DD/MM/YYYY").diff(new Date, 'days') <= 30) {
              this.ShowRenew = true
              this.deactivated = true
              Swal.fire({
                //html: `Andica Accounts Production Software Licence is going to expire on ${moment(data[0].EndDate, "DD/MM/YYYY").format("DD/MM/YYYY")} <br/>Do you want to renew your subscription?`,
                //html: `<b>Licence about to expire!</b> <br> Your subscription is going to expire on ${moment(data[0].EndDate, "DD/MM/YYYY").format("DD/MM/YYYY")} ${TUEndtime}.<br> Do you want to renew your subscription?`,
                html: `<b>Licence Expiring Soon!</b> <br> Andica Accounts Production Software licence is about to expire on ${moment(data[0].EndDate, "DD/MM/YYYY").format("DD/MM/YYYY")}.`,
                //html: `<b>Licence about to expire!</b> <br> Your subscription is going to expire on ${TUEndDate}.<br> Do you want to renew your subscription?`,
                icon: "warning",
                confirmButtonText: "Renew",
                cancelButtonText: "Cancel",
                showCancelButton: true,
                allowOutsideClick: false
              }).then((result) => {
                if (result.value) {
                  this.SubscriptionApiService.Upgrade("Renew", this.centralUserId, this.ProductId, this.NumberOfCompanies, this.NumberOfUsers, this.PlanId, this.PricingId, this.TaxYear);
                }
                else {
                  Swal.close()
                }
              })
            }

            if (data[0].CreatedBy == null) {
              localStorage.setItem('MasterId', data[0].CentralUserId)
            }
            else
              localStorage.setItem('MasterId', data[0].CreatedBy)
          }
          else {
            this.deactivated = true
            this.ShowRenew = true
            Swal.fire({
              //html: "Andica Accounts Production Software Licence has been expired!<br/>Please renew your licence.",
              html: `<b>Licence Expired!</b> <br>Andica Accounts Production Software licence has been expired on ${moment(data[0].EndDate, "DD/MM/YYYY").format("DD/MM/YYYY")}.`,
              icon: "warning",
              confirmButtonText: "Renew",
              //cancelButtonText: "Cancel",
              //showCancelButton:true,
              allowOutsideClick: false,
            }).then((result) => {
              if (result.value) {
                this.SubscriptionApiService.Upgrade("Renew", this.centralUserId, this.ProductId, this.NumberOfCompanies, this.NumberOfUsers, this.PlanId, this.PricingId, this.TaxYear);
              }
              else
                Swal.close()
            })
          }

        }
      }
      else {
        this.deactivated = true
        //Swal.fire({
        //  icon: "warning",
        //  title: "Andica Accounts Production",
        //  html: "Your account has been deactivated!<br>Please contact Andica support portal for assistance.",
        //  allowOutsideClick: false
        //}).then((result) => {
        //  if (result.value) {
        //    this.logOut();
        //    //window.location.href = "https://andica.com"
        //  }
        //})
        this.toastr.error('Unauthorised, please try again.')
        this.toastr.toastrConfig.autoDismiss = true;
        this.toastr.toastrConfig.maxOpened = 1;
        this.toastr.toastrConfig.preventDuplicates = true;
        setTimeout(() => {
          localStorage.clear();
          //if (!location.href.includes('localhost')) {
          //  window.location.href = this.ConfigService.andicaCentralURL();
          //} else {
            this.logOut();
          //}
        }, 1000)
      }
    })
    //}
  }

  logOut() {
    debugger
    //Remove everything from localstorage
    var Useloginlist = new Userhistory()
    Useloginlist.UserId = this.LoggedInUserId
    Useloginlist.UserLoginHistoryId = this.UserLoginHistoryId
    Useloginlist.LastAccessedPeriodstart = localStorage.getItem("accountsstart")
    Useloginlist.LastAccessedPeriodend = localStorage.getItem("accountsend")
    Useloginlist.LastAccessedBusiness = this.companyName

    if (this.UserLoginHistoryId == null) {
      Useloginlist.AdminLogin_time = 'true'
      Useloginlist.AdminLogout_time = 'false'
    }
    else {
      Useloginlist.AdminLogin_time = 'false'
      Useloginlist.AdminLogout_time = 'true'
    }
    this.companyService.InsertLoginHistory(Useloginlist).subscribe((res => {
      if (res) {
        console.log(res);
        this.UserLoginHistoryId = res;
        this.globalLogoutService.publishLogout();
        this.oauthService.logOut()
        sessionStorage.clear();
        localStorage.clear();
        sessionStorage.setItem('ProductLogedout', 'Yes')

      }
    }))

    //this.modalService.dismissAll();
    //Send null to 'BehaviorSubject' so anyone subscribed to this can be notified
    //this.currentUserSubject.next(null);
  }
  insertTime() {
    var Useloginlist = new Userhistory()
    Useloginlist.UserId = this.LoggedInUserId
    Useloginlist.UserLoginHistoryId = this.UserLoginHistoryId
    if (this.UserLoginHistoryId == null) {
      Useloginlist.AdminLogin_time = 'true'
      Useloginlist.AdminLogout_time = 'false'
    }
    else {
      Useloginlist.AdminLogin_time = 'false'
      Useloginlist.AdminLogout_time = 'true'
    }
    localStorage.setItem("temploginhistory", "1")
    this.companyService.InsertLoginHistory(Useloginlist).subscribe((res => {
      if (res) {
        this.UserLoginHistoryId = res;
        localStorage.setItem('UserLoginHistroyId', this.UserLoginHistoryId)

      }
    }))

  }
  parseDate(list: any[]) {
    debugger
    if (list !== null) {
      list.forEach(function (arrayItem) {
        for (let prop in arrayItem) {
          //let value = arrayItem[prop];
          const formats = [moment.ISO_8601, "YYYY-MM-DD HH*mm*ss"];
          if (isNaN(arrayItem[prop])) {
            if (moment(arrayItem[prop], formats, true).isValid()) {
              arrayItem[prop] = moment(arrayItem[prop]).format("DD/MM/YYYY");
            }
          }
        }
      });
    }
  }

  getDirectors(RegNo) {
    return this.http.get(this.companyInformation + '/GetDirectors/' + RegNo)
  }

  //show bubble start
  private showBubble$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  Showbubble = this.showBubble$.asObservable();

  get getbubble(): boolean {
    debugger
    return this.showBubble$.value;
  }
  setShowBubble(ShowBubble: boolean) {
    debugger
    this.showBubble$.next(ShowBubble);
  }


  savebubble(data) {
    return this.http.post(this.url + '/SaveShowBubble', data)
  }
  insertshowbubble(formdata) {
    this.savebubble(formdata).subscribe((data: any) => {
      debugger
      if (data != null) {
        if (this.getbubble) {
          this.showBubbleSpinner = true;
          setTimeout(() => {
            this.showBubbleSpinner = false;
          }, 1000)
        }
        this.accountsService.setShowBubble(data == 0 ? false : true)
        this.setShowBubble(data == 0 ? false : true)
      } else {
        this.accountsService.setShowBubble(false)
      }
    })
  }

  calculateDateDifference(startDate: Date, endDate: Date): any[] {
    const diffInMilliseconds = endDate.getTime() - startDate.getTime();
    const diffInDays = diffInMilliseconds / (1000 * 3600 * 24);
    const years = Math.floor(diffInDays / 366);
    const months = Math.floor((diffInDays % 366) / 30);
    return [years, months];
  }

  expiryMessage() {
    if (this.isLicenceExpired) {
      Swal.fire({
        //html: "Andica Accounts Production Software Licence has been expired!<br/>Please renew your licence.",
        html: `<b>Licence Expired!</b> <br>Andica Accounts Production Software licence has been expired on ${moment(this.TUEndDate1, "DD/MM/YYYY").format("DD/MM/YYYY")}.`,
        icon: "warning",
        confirmButtonText: "Renew",
        //showCancelButton:true,
        //cancelButtonText:"Cancel",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.value) {
          this.SubscriptionApiService.Upgrade("Renew", this.centralUserId, this.ProductId, this.NumberOfCompanies, this.NumberOfUsers, this.PlanId, this.PricingId, this.TaxYear);
        }
        else {
          Swal.close()
          //this.logOut();
        }
      })
      return false
    }
    else {
      return true
    }
  }

  getPageSelectionData(data): Observable<ReportSelectionModel[]> {
    return this.http.get<ReportSelectionModel[]>(this.masterUrl + '/GetReportSelectionData?APPeriodId=' + data)
  }

  checkUserAuthentication(userName): Observable<UserRegistrationModel> {
    debugger
    return this.http.get<UserRegistrationModel>(this.acctSoftURL + "/UserRegistration/authenticate?userName=" + userName)
  }

  GetBusinessUsers(searchTerm: any, currentPage: any, itemsPerPage: any, isVatBusiness: any, cid?: any): Observable<BusinessModel> {
    debugger
    const currentUser = this.getAcctSoftUser;
    if (cid == null) {
      cid = 0
    }
    const payload = {
      searchTerm: searchTerm,
      currentPage: currentPage,
      itemsPerPage: itemsPerPage,
      isVatBusiness: isVatBusiness,
      cid: cid,
      Bid: currentUser.UserID
    }
    return this.http.post<BusinessModel>(this.acctSoftURL + "/BusinessInformation/GetBusinessUsers", payload)
  }

  getTrialBalanceAcctsoft(form: TrailbalancemodelForImpAcctsoft): Observable<any> {
    debugger;
    return this.http.post<TrailbalancemodelForImpAcctsoft>(this.acctSoftURL + "/CreateCustomer/GetTrialBalance", form); //Chart of Accounts
  }
  GetAccountsWithAccCodes(templateType: any): Observable<any> {
    debugger;
    return this.http.get(this.trailBalanceUrl + '/GetAccountsWithAccCodes?templateType=' + templateType);
  }
}
export class Userhistory {
  UserLoginHistoryId
  LastLogin: any
  LastLogout: any
  AdminLogout_time: any
  AdminLogin_time: any
  IsActive: any
  UserId: any
  CreatedBy: any
  CreatedDate: any
  ModifiedBy: any
  ModifiedDate: any
  LastAccessedPeriodstart: any
  LastAccessedPeriodend: any
  LastAccessedBusiness: any
}




